import styled from '@emotion/styled';
import {Box, Grid} from '@mui/material';

export const PageLoaderGrid = styled(Grid)`
  height: 100%;
  width: 100%;
  display: flex;
  // margin-top: 5rem;
  align-items: center;
  justify-content: center;
`;

export const MainGrid = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
  flex-wrap: nowrap;
`;

export const LeftGrid = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  // width: 20rem;
  height: 100%;
`;

export const TopGrid = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0;
  height: 3.5rem;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
  flex-wrap: nowrap;
`;

export const RightGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-left: 1px solid rgba(145, 158, 171, 0.2);
  // flex: 1;
  height: 100%;
  flex-wrap: nowrap;
`;

export const TopActionGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0;
  height: 6.9vh;
  width: 100%;
  border-bottom: 1px solid rgba(145, 158, 171, 0.2);
  flex-wrap: nowrap;
`;

export const PermissionsWrapperGrid = styled(Grid)`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
  height: 78vh;
  row-gap: 2px;
  background-color: #f9f9f9;
  overflow: auto;
  @media screen and (max-height: 800px) {
    height: 68vh;
  }

  @media screen and (max-height: 600px) {
    height: 60vh;
  }
`;

export const PermissionsLoaderContainerGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin: 6rem auto auto auto;
`;

export const PermissionsContainerGrid = styled(Grid)`
  width: fit-content;
  height: 95%;
  margin: 1rem auto auto 1rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const NoPermissionsContainerGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding-top: 5rem;
  padding-right: 1rem;
  padding-left: 1rem;
`;

export const RoleNameTypographyGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 1.5rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #f0f0f0;
`;

export const ActionButtonsGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: 8px;
`;

export const PermissionsForm = styled(Box)`
  display: inline-block;
  padding: 0.75em 1.5em;
  margin: 0.5rem;
  border-radius: 8px;
  border: 1px solid #d8d8d8;
  width: 300px;
  height: min-content;
  background-color: white;
  break-inside: avoid;
  object-fit: cover;
`;

export const SearchGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const SearchContainerGrid = styled(Grid)`
  padding: 0.4rem;
  width: 100%;
`;
